module.exports = __webpack_public_path__ + "media/images/likely_smiley-56bce7637c625d0d928689d4409a6914.svg";